var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 1054,
    viewBox: "0 0 98 1054",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7439 85.9156C16.4222 55.5 70.3703 0 70.3703 0H42.7438C42.7438 0 -3.75588 52.8312 0.244009 85.9156C4.2439 119 54.2439 140.5 67.744 164.16C81.2441 187.82 3.40005 221.208 7.24401 267.975C10.5782 308.54 57.6027 314.117 66.244 353.89C69.744 370 1.24401 411.591 9.24401 450.545C17.244 489.5 71.744 522 68.244 550.269C64.744 578.538 13.1831 596.919 10.744 637.719C8.90383 668.5 67.744 701.232 67.744 737.442C67.744 769 4.48365 786.647 11.107 838.801C15.8185 875.9 73.1069 898.353 65.6069 915C58.1069 931.647 17.3262 950.595 12.244 987.006C9.24401 1008.5 41.244 1054 75.244 1054H97.744C97.744 1054 24.8871 1014.51 28.0656 987.006C31.244 959.5 80.744 940.5 83.8083 912.853C86.8726 885.206 32.4386 873.609 28.0656 836.654C22.8102 792.243 77.0231 781.662 83.8083 737.442C90.2439 695.5 28.0656 668 28.0656 637.719C28.0656 596.898 81.485 591.023 83.8083 550.269C86.3642 505.435 42.2308 493.164 28.0656 450.545C18.744 422.5 83.8083 377.5 83.8083 353.89C83.8083 313.569 31.3518 308.158 28.0656 267.975C24.2921 221.834 89.5487 210.086 83.8083 164.16C79.1136 126.6 23.0656 116.331 19.7439 85.9156Z",
    fill: "#D7BE82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/Divider.bff1000d3b25df8e4c1d5365ab883c61.svg";
export { ForwardRef as ReactComponent };